import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, input, InputSignal, OnInit, signal, ViewChild, WritableSignal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { Quiz } from 'src/app/models/moodle';
import { MoodleQuiz } from 'src/app/models/moodle-quiz';
import Swiper from 'swiper';
import { register } from 'swiper/element/bundle';
import { AuthService } from 'src/app/services/auth.service';

register();

@Component({
  selector: 'app-moodle-quiz',
  templateUrl: './moodle-quiz.component.html',
  styleUrls: ['./moodle-quiz.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, IonicModule, RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MoodleQuizComponent extends MoodleQuiz implements OnInit {
  @ViewChild("quizSwiper", { static: false }) quizSwiperElement: ElementRef;
  public quizzes: InputSignal<Array<Quiz>> = input<Array<Quiz>>([]);
  public totalSlide: WritableSignal<number> = signal<number>(0);

  get quizSwiper(): Swiper {
    return this.quizSwiperElement?.nativeElement.swiper;
  }  

  constructor(private router: Router, private auth: AuthService) { 
    super();
  }
  
  async ngOnInit() {    
    await this.createQuiz(this.quizzes());
    this.totalSlide.set(this.quizSwiper.slides.length);
    // this.quizSwiperElement.nativeElement.addEventListener("keydown", (event: Event) => {
    //   event.preventDefault();
    //   event.stopPropagation();
    // })

    // this.quizSwiperElement.nativeElement.addEventListener("focus", (event: Event) => {
    //   event.preventDefault();
    //   event.stopPropagation();
    // }, true)

    this.quizSwiper.slides.forEach(s => s.setAttribute('tabindex', '-1'));
  }
  
  nextQuestion(quizIdx: number, questionIdx: number) {
    this.processQuiz(quizIdx, questionIdx);
    this.quizSwiper.slideNext();  
  }

  async endQuiz(){
    await this.submitQuiz();
    // this.router.navigate(['/dashboard']);
    window.location.assign('https://iacdp.profenpoche.com/local/plugin_iacdp/login.php?token=' + this.auth.currentUser().moodleToken);
  }
}
